require('./insuranceRequestWizardStep3.scss');
require('./insuranceRequestWizardStep3.override.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ utils
const { FormattedText, formatText, getLanguage } = require('core/i18n').i18n;
const { formatAmount } = require('utilities/currencyHelper');

// @ constants
const { EVENTS_INSURANCE_HOME } = require('../../../insuranceConstants/insuranceRequestTags');
const { EURO_SYMBOL, SECOND_STEP, THIRD_STEP, FOURTH_STEP } = require('constants/index');
const { PLANS: { BASIC }, PROPERTY_USAGE: { RENT }, NA } = require('../../../insuranceConstants/insuranceRequestHome');
const {
    INSURANCE_USABILITY_IMPROVEMENTS,
    INSURANCE_EXTRA_SERVICE
} = require('constants/flagBasedFeatures');

// @ commons
const BlockInfo = require('components/contactCenter/blockInfo/blockInfo');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @ commonsComponents
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');

// @ components
const InsuranceRequestPlans = require('../../insuranceRequestPlansCC/insuranceRequestPlansCC');
const InsuranceRequestWizardStep3Tooltips = require('./insuranceWizardStep3Components/insuranceRequestWizardStep3Tooltips');
const InsuranceRequestWizardStep3PlanModal = require('../insuranceRequestWizardStep3/insuranceWizardStep3Components/insuranceRequestWizardStep3PlanModal');
const SpecialCoveragesModal = require('../specialCoveragesModal/specialCoveragesModal')

class InsuranceRequestWizardStep3 extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showSpecialCoveragesModal: false
        };

        this.handleTooltipMouseOver = this.handleTooltipMouseOver.bind(this);
        this.handleTooltipMouseOut = this.handleTooltipMouseOut.bind(this);
        this.recordEventSelectPlan = this.recordEventSelectPlan.bind(this);
        this.handleShowSpecialCoveragesModal = this.handleShowSpecialCoveragesModal.bind(this);
        this.handleToggleSpecialCoveragesModal = this.handleToggleSpecialCoveragesModal.bind(this);
        this.onHandleModalClose = this.onHandleModalClose.bind(this);
        this.handleInsurancePlanModal = this.handleInsurancePlanModal.bind(this);
    }

    componentWillMount() {
        const {
            getQuotationData,
            immInsuranceWizard,
            hasSimulationChanged,
            setData
        } = this.props;
        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const step3LoadingFromDetailsTable = immInsuranceWizardStep3.get('step3LoadingFromDetailsTable')

        setData(THIRD_STEP, { basicPlanModalValidation: false });
        if (step3LoadingFromDetailsTable) {
            setData(THIRD_STEP, { step3LoadingFromDetailsTable: false });
        } else {
            getQuotationData(hasSimulationChanged);
        }
    }

    componentWillUnmount() {
        const { linkClientSuccessInitialState } = this.props
        linkClientSuccessInitialState();
    }

    handleTooltipMouseOver(link) {
        this.tooltipHover = setTimeout(() => {
            this.props.recordEvent(EVENTS_INSURANCE_HOME.STEP_3_LINKS_HOVER, link);
        }, 2000);
    }

    handleTooltipMouseOut() {
        // this.tooltipHover.close && clearTimeout(this.tooltipHover);
        clearTimeout(this.tooltipHover);
    }

    recordEventSelectPlan(plan) {
        this.props.recordEvent(EVENTS_INSURANCE_HOME.STEP_3_SELECT_PLAN_CLICK, plan);
    }

    handleShowSpecialCoveragesModal() {
        this.setState({ showSpecialCoveragesModal: true });
    }

    handleToggleSpecialCoveragesModal() {
        this.setState({ showSpecialCoveragesModal: false });
    }

    buildContactCenterMandatoryReading() {
        const { isRelated } = this.props;
        const poeditorPrefix = 'insuranceRequestHomeCC';
        const message = isRelated
            ? `${poeditorPrefix}-${poeditorPrefix}_relatedMandatoryReadingStep3`
            : `${poeditorPrefix}-${poeditorPrefix}_mandatoryReadingStep3`;

        return (
            <BlockInfo
                extraClass={'insurance-request-wizard-step-three__block-info'}>
                {formatText(message)}
            </BlockInfo>
        )
    }

    buildCustomizeCoverage() {
        const { immInsuranceWizard } = this.props;
        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const disableCustomizeButton = !immInsuranceWizardStep3.get("insurancePlan");

        return (
            <div className="col-sm-12 insurance-request-wizard-step-three__customize-coverage">
                <OKMessage
                    type="informative"
                >
                    <div className="insurance-request-wizard-step-three__customize-coverage-description">
                        <FormattedText
                            value="insuranceRequestHomeCC-insuranceRequestHomeCC_customizeCoverageTitleStep3"
                            className="insurance-request-wizard-step-three__customize-coverage-description-title"
                        />
                        <FormattedText value="insuranceRequestHomeCC-insuranceRequestHomeCC_customizeCoverageDescriptionStep3" />
                    </div>
                    <div className="insurance-request-wizard-step-three__customize-coverage-button">
                        <OKButton
                            size="regular"
                            modifier="primary"
                            disabled={disableCustomizeButton}
                            onClick={this.handleShowSpecialCoveragesModal}
                        >
                            <FormattedText value="insuranceRequestHomeCC-insuranceRequestHomeCC_customizeCoverageButtonStep3" />
                        </OKButton>
                    </div>
                </OKMessage>
            </div>
        );
    }

    buildSpecialCoveragesModal() {
        const { showSpecialCoveragesModal } = this.state;
        const { getQuotationData, immInsuranceWizard, setData } = this.props;
        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);

        return showSpecialCoveragesModal ? (
            <SpecialCoveragesModal
                getQuotationData={getQuotationData}
                showModal={showSpecialCoveragesModal}
                onHandleToggle={this.handleToggleSpecialCoveragesModal}
                immInsuranceWizardStep3={immInsuranceWizardStep3}
                setData={setData} />
        ) : null;
    }

    onHandleModalClose() {
        const { setData } = this.props;
        setData(THIRD_STEP, { basicPlanModalValidation: false });
    }

    handleInsurancePlanModal(immInsuranceWizardStep3) {
        const { validateStep } = this.props;
        const associatingClient = immInsuranceWizardStep3.get('isFetchingSelectPlan') || immInsuranceWizardStep3.get('isLinkingInProgress');
        const basicPlanModalValidation = immInsuranceWizardStep3.get('basicPlanModalValidation');

        return (
            <InsuranceRequestWizardStep3PlanModal
                handleRequestClose={this.onHandleModalClose}
                isOpen={basicPlanModalValidation}
                loading={associatingClient}
                onRequestAccept={() => validateStep(FOURTH_STEP, true)}
            />
        );
    }

    buildLegalBoxInfo() {
        let {
            immFlagBasedFeatures,
            isRelated,
            isPostAppraisal
        } = this.props;

        return !immFlagBasedFeatures.get(INSURANCE_EXTRA_SERVICE) && (
            <div className="row">
                <div className="col-sm-12 insurance-request-wizard-step-three__box-info">
                    <InsuranceRequestWizardStep3Tooltips
                        isRelated={isRelated}
                        isPostAppraisal={isPostAppraisal}
                        onHandleTooltipMouseOver={this.handleTooltipMouseOver}
                        onHandleTooltipMouseOut={this.handleTooltipMouseOut}
                    />
                </div>
            </div>
        );
    }

    render() {
        const {
            immFlagBasedFeatures,
            immInsuranceState,
            immInsuranceWizard,
            insuranceSelectPlan,
            onChangeShowCoverageDetailTable,
            isRelated,
            selectPlanInRelatedWizardStep3,
            onhandleChangeSelectedPlanInStateComponent,
            setData,
            webActuationLimitsIsEnabled,
        } = this.props;

        const insuranceUsabilityImprovementsFlag = !!immFlagBasedFeatures.get(INSURANCE_USABILITY_IMPROVEMENTS);
        const immInsuranceWizardStep2 = immInsuranceWizard.getIn(['steps', SECOND_STEP]);
        const immInsuranceWizardStep3 = immInsuranceWizard.getIn(['steps', THIRD_STEP]);
        const fetchingQuotationData = immInsuranceWizardStep3.get('isFetchingQuotation');
        const fetchingCoveragesData = immInsuranceWizardStep3.get('isFetchingCoverages');
        const coveragesAndPlansSize = immInsuranceWizardStep3.get('coveragesAndPlansData').size === 0;
        const coveragesDetailsMedium = immInsuranceWizardStep3.get('isFetchingDetailsMedium');
        const coverageDetailsBasic = immInsuranceWizardStep3.get('isFetchingDetailsBasic');
        const coverageDetailsHigh = immInsuranceWizardStep3.get('isFetchingDetailsHigh');
        const fetchingCoveragesDetails = coveragesDetailsMedium || coverageDetailsBasic || coverageDetailsHigh;

        if (fetchingQuotationData || fetchingCoveragesData || coveragesAndPlansSize || fetchingCoveragesDetails) {
            return <LoadingSection />;
        }

        const valueToEnsure = formatText('insuranceRequestHome-step3ValuesToEnsure');
        const step3Title = formatText('insuranceRequestHome-step3InsurancesOptionsTitle');
        const contentTitle = formatText('insuranceRequestHome-step3InsuranceContent');
        const continentTitle = formatText('insuranceRequestHome-step3InsuranceContinent');
        const language = getLanguage();
        const contentValue = formatAmount(immInsuranceWizardStep2.get("content"), language, 0);
        const continentValue = formatAmount(immInsuranceWizardStep2.get("continent"), language, 0);

        const showErrorMessage = immInsuranceWizardStep3.get('fieldErrors') && !immInsuranceWizardStep3.get('insurancePlan')
        const errorMessage = showErrorMessage && (
            <div className="col-xs-12 insurance-request-wizard-step-three__field-errors-message">
                <OKMessage type="warning">
                    <FormattedText value="insuranceRequestHome-step3ValidationError" />
                </OKMessage>
            </div>
        );


        let insurancePlan = '';
        let propertyUsage = '';
        let isUsagePropertyRentAndBasicPlan;
        if (!isRelated) {
            insurancePlan = immInsuranceWizardStep3.get("insurancePlan");
            propertyUsage = immInsuranceWizardStep2.get("propertyUsage");
            isUsagePropertyRentAndBasicPlan = insurancePlan === BASIC && propertyUsage === RENT
        }
        const buildCustomizeCoverage = webActuationLimitsIsEnabled ? this.buildCustomizeCoverage() : null;
        return (
            <div className="row insurance-request-wizard-step-three">
                <header className="insurance-request-wizard-step-three__step-title">{step3Title}</header>
                {errorMessage}
                <div className="col-xs-12 insurance-request-wizard-step-three__box-info">
                    {this.buildContactCenterMandatoryReading()}
                    <div className="insurance-request-wizard-step-three__box-info-content">
                        <span className="insurance-request-wizard-step-three__box-info-text-bold">{valueToEnsure}</span>
                        <span className="insurance-request-wizard-step-three__box-info-text">
                            <i className="icon-continente insurance-request-wizard-step-three__icon"></i>
                            {continentTitle}
                            <span className="insurance-request-wizard-step-three__box-info-text-bold">
                                {`${continentValue} ${EURO_SYMBOL}`}
                            </span>
                        </span>
                        <span className="insurance-request-wizard-step-three__box-info-text">
                            <i className="icon-contenido insurance-request-wizard-step-three__icon"></i>
                            {contentTitle}
                            <span className="insurance-request-wizard-step-three__box-info-text-bold">
                                {isUsagePropertyRentAndBasicPlan ? NA : `${contentValue} ${EURO_SYMBOL}`}
                            </span>
                        </span>
                    </div>
                </div>

                <div className="col-sm-12">
                    <InsuranceRequestPlans
                        isRelated={isRelated}
                        selectPlanInRelatedWizardStep3={selectPlanInRelatedWizardStep3}
                        onChangeShowCoverageDetailTable={onChangeShowCoverageDetailTable}
                        insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                        immInsuranceState={immInsuranceState}
                        immInsuranceWizardStep={immInsuranceWizardStep3}
                        propertyInformation={immInsuranceWizardStep2}
                        insuranceSelectPlan={insuranceSelectPlan}
                        onhandleChangeSelectedPlanInStateComponent={onhandleChangeSelectedPlanInStateComponent}
                        setData={setData}
                        recordEventSelectPlan={this.recordEventSelectPlan}
                        webActuationLimitsIsEnabled={webActuationLimitsIsEnabled}
                    />
                </div>
                {
                    isUsagePropertyRentAndBasicPlan &&
                    (
                        <div className="insurance-request-wizard-step-three__messagge-container col-sm-12">
                            <div className="insurance-request-wizard-step-three__messagge">
                                <OKMessage
                                    visible
                                    type="informative"
                                >
                                    <div className="insurance-request-wizard-step-three__disclaimer-text">
                                        <FormattedText value="insuranceRequestHome-step3InformativeDisclaimer" />
                                    </div>
                                </OKMessage>
                            </div>
                        </div>
                    )
                }
                {buildCustomizeCoverage}
                {this.buildLegalBoxInfo()}
                {this.buildSpecialCoveragesModal()}
                {insuranceUsabilityImprovementsFlag && this.handleInsurancePlanModal(immInsuranceWizardStep3)}
            </div>
        )
    }
}

InsuranceRequestWizardStep3.propTypes = {
    getCoveragesAndPlansDetailsData: PropTypes.func.isRequired,
    getQuotationData: PropTypes.func.isRequired,
    hasSimulationChanged: PropTypes.bool.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    immInsuranceState: PropTypes.object.isRequired,
    immInsuranceWizard: PropTypes.object.isRequired,
    insuranceSelectPlan: PropTypes.func.isRequired,
    isPostAppraisal: PropTypes.bool,
    isRelated: PropTypes.bool,
    linkClientSuccessInitialState: PropTypes.func,
    onChangeShowCoverageDetailTable: PropTypes.func.isRequired,
    onhandleChangeSelectedPlanInStateComponent: PropTypes.func,
    recordEvent: PropTypes.func.isRequired,
    selectPlanInRelatedWizardStep3: PropTypes.func,
    setData: PropTypes.func.isRequired,
    validateStep: PropTypes.func,
    webActuationLimitsIsEnabled: PropTypes.bool,
};

InsuranceRequestWizardStep3.defaultProps = {
    isRelated: false,
    isPostAppraisal: false,
    selectPlanInRelatedWizardStep3: () => { },
    onhandleChangeSelectedPlanInStateComponent: () => { },
    linkClientSuccessInitialState: () => { },
};

module.exports = InsuranceRequestWizardStep3;
